import type { FolderUser } from '../types';
import { useQueryClient } from '@tanstack/react-query';
import { useToast } from '@workramp/ui';
import { useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { FOLDERS_KEY } from '../constants';

const FOLDER_PERMISSIONS_UPDATED = 'Folder editor permissions updated.';

export type FolderPermissionsPut = {
  groups: Omit<FolderUser, 'displayName' | 'email' | 'inheritedFolder' | 'imgUrl'>[];
  users: Omit<FolderUser, 'displayName' | 'email' | 'inheritedFolder' | 'imgUrl'>[];
};

const setFolderPermissionUsers = ({ folderId, groups, users }) =>
  FetchPromise.put(`item_folders/${folderId}/set_editors`, { groups, users });

export const useSetFolderPermissionUsers = (folderId: string) => {
  const toast = useToast();
  const client = useQueryClient();

  return useDefaultMutation(
    ({ groups, users }: FolderPermissionsPut) => setFolderPermissionUsers({ folderId, groups, users }),
    {
      onSuccess: () => {
        // due to inheritance, invalidate all folders
        // i.e. edit parent folder would display stale data for child folder
        client.invalidateQueries([FOLDERS_KEY]);
        toast.open({ children: FOLDER_PERMISSIONS_UPDATED });
      },
    },
  );
};
